import { render, staticRenderFns } from "./EventDetailCard.vue?vue&type=template&id=7f70965d&scoped=true&"
import script from "./EventDetailCard.vue?vue&type=script&lang=js&"
export * from "./EventDetailCard.vue?vue&type=script&lang=js&"
import style0 from "./EventDetailCard.vue?vue&type=style&index=0&id=7f70965d&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f70965d",
  null
  
)

export default component.exports